import { Link } from "@tanstack/react-router";
import { Logo } from "../components/ui";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-4 p-8 text-center">
      <Logo className="text-2xl" />
      <h1 className="text-2xl font-bold">Página não encontrada</h1>
      <Link to="/" className="btn-primary">
        Voltar ao início
      </Link>
    </div>
  );
}
